import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import { queryClient } from '@/lib/react-query';

export const useUpdateDefinition = () => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    mutationFn: ({ payload }) =>
      axios.post('api/v2/agent/search/metric/enable', payload),
    onSuccess: (data, { payload, metadata }) => {
      addNotification({
        type: 'success',
        title:
          `Successfully Updated "${metadata.name}" Definition` || data?.message,
      });
      queryClient.setQueryData('getConnectedDefinitionsList', (prev) => {
        let temp = structuredClone(prev || {});
        if (Array.isArray(temp?.metrics) && temp.metrics.length > 0) {
          temp.metrics = temp.metrics.map((metric) => {
            if (metric?._id === payload?.metricId) {
              const newData = {
                ...metric,
                ...(payload?.name && { name: payload.name }),
                ...(payload?.description && {
                  description: payload.description,
                }),
                ...(payload?.category && { category: payload.category }),
                ...(typeof payload?.enabled === 'boolean' && {
                  enabled: payload.enabled,
                }),
              };
              return newData;
            } else {
              return metric;
            }
          });
        }
        return temp;
      });
    },
    onError: (error) => {
      addNotification({ type: 'error', title: error?.message });
    },
  });
};
